var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50748 15.946C5.85686 14.3384 2.87817 11.0729 2.87817 8.44154C2.87817 4.80161 5.15796 2.375 8.57765 2.375C11.9973 2.375 14.2771 4.80161 14.2771 8.44154C14.2771 11.0729 11.2984 14.3384 9.64782 15.946C9.04559 16.5325 8.10971 16.5325 7.50748 15.946ZM8.57765 10.1667C9.75805 10.1667 10.715 9.21527 10.715 8.04167C10.715 6.86806 9.75805 5.91667 8.57765 5.91667C7.39725 5.91667 6.44035 6.86806 6.44035 8.04167C6.44035 9.21527 7.39725 10.1667 8.57765 10.1667Z",
    fill: "#6C757D"
  })));
};
export default SvgLocation;